import { render } from "./IaCredits.vue?vue&type=template&id=a56ab2fa&scoped=true"
import script from "./IaCredits.vue?vue&type=script&lang=js"
export * from "./IaCredits.vue?vue&type=script&lang=js"

import "./IaCredits.vue?vue&type=style&index=0&id=a56ab2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56ab2fa"]])

export default __exports__